
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5918',
  depVersions: {
  "data-privacy-request-ui": "static-1.5918",
  "client-types": "static-1.504",
  "data-fetching-client": "static-1.10039",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8429",
  "hub-http-shared-msw-handlers": "static-1.10758",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11884",
  "I18n": "static-7.1690",
  "jasmine-runner": "static-1.6840",
  "quartz": "static-1.7561",
  "react-dlb": "static-1.92",
  "rpc-client-utils": "static-1.5058",
  "ui-components-test-utils": "static-1.6021",
  "UIComponents": "static-3.8830",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.97",
  "foundations-assets": "static-1.5280",
  "foundations-components": "static-1.8622",
  "foundations-components-test-utils": "static-1.6105",
  "foundations-theming": "static-1.4871",
  "hub-http": "static-1.6602",
  "hubspot-url-utils": "static-1.4383",
  "quartz-config": "static-1.1339",
  "quartz-core": "static-1.6780",
  "quartz-routing": "static-1.991",
  "quick-fetch": "static-1.4181",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-rhumb": "static-1-fix-undefined-routespec-crash.8",
  "SharedI18nStrings": "static-1.186",
  "ui-addon-i18n": "static-1.11540",
  "usage-tracker": "static-1.7703",
  "usage-tracker-anonymous": "static-1.6120",
  "usage-tracker-core": "static-1.7553",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3838",
  "quartz-webpack": "static-1.3785",
  "bend-plugin-quartz-routing": "static-1.639",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.92",
  "HeadJS": "static-2.810",
  "framer-motion": "static-1.82",
  "hs-test-utils-bend-plugin": "static-1.3540",
  "msw": "static-1.39",
  "msw-config": "static-1.15",
  "testing-library": "static-1.162",
  "ts-schema": "static-1.4350",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "react-utils": "static-2.5611",
  "StyleGuideUI": "static-3.511",
  "jasmine": "static-4.4702",
  "bend-plugin-chirp-manifest": "static-1.468",
  "chirp-fetch": "static-1.2293",
  "HubStyle": "static-2.12191",
  "ui-addon-draggable": "static-3.5138",
  "cssUtils": "static-1.1013",
  "hs-story-utils": "static-1.9816",
  "icons": "static-2.698",
  "react-create-root-preference": "static-1.87",
  "react-select-plus": "static-1.116",
  "react-virtualized": "static-2.110",
  "ui-images": "static-2.1268",
  "bend-plugin-foundations-components": "static-1.4891",
  "floating-ui": "static-1.66",
  "foundations-theming-specialty": "static-1.2587",
  "react-aria": "static-1.75",
  "tanstack-table": "static-1.64",
  "trellis-assets": "static-1.2878",
  "ui-fonts": "static-1.1146",
  "foundations-components-legacy": "static-1.1647",
  "bend-plugin-foundations-theming": "static-1.3354",
  "foundations-theming-base": "static-1.3856",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.350",
  "opentelemetry-fe-types": "static-1.177",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.895",
  "hubspotter-http": "static-1.4916",
  "mobile-manifest-mixins": "static-1.591",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1.552",
  "quartz-auth": "static-1.1236",
  "quartz-head": "static-1.1226",
  "quartz-i18n": "static-1.1236",
  "quartz-test": "static-1.1236",
  "quartz-tracking": "static-1.940",
  "trellis-components": "static-1.2897",
  "usage-tracker-container": "static-1.7693",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3452",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.81",
  "sassPrefix": "static-1.281",
  "stylex-utils": "static-1.156",
  "trellis-theming": "static-1.1369",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.94",
  "hubspotter-http-shared-msw-handlers": "static-1.10756",
  "usage-tracker-session-replay": "static-1.5389",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "tanstack-virtual": "static-1.41",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5918",
  "client-types": "/client-types/static-1.504",
  "data-fetching-client": "/data-fetching-client/static-1.10039",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8429",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10758",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11884",
  "I18n": "/I18n/static-7.1690",
  "jasmine-runner": "/jasmine-runner/static-1.6840",
  "quartz": "/quartz/static-1.7561",
  "react-dlb": "/react-dlb/static-1.92",
  "rpc-client-utils": "/rpc-client-utils/static-1.5058",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6021",
  "UIComponents": "/UIComponents/static-3.8830",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.97",
  "foundations-assets": "/foundations-assets/static-1.5280",
  "foundations-components": "/foundations-components/static-1.8622",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6105",
  "foundations-theming": "/foundations-theming/static-1.4871",
  "hub-http": "/hub-http/static-1.6602",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "quartz-config": "/quartz-config/static-1.1339",
  "quartz-core": "/quartz-core/static-1.6780",
  "quartz-routing": "/quartz-routing/static-1.991",
  "quick-fetch": "/quick-fetch/static-1.4181",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-rhumb": "/react-rhumb/static-1-fix-undefined-routespec-crash.8",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11540",
  "usage-tracker": "/usage-tracker/static-1.7703",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6120",
  "usage-tracker-core": "/usage-tracker-core/static-1.7553",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3838",
  "quartz-webpack": "/quartz-webpack/static-1.3785",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.639",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.92",
  "HeadJS": "/HeadJS/static-2.810",
  "framer-motion": "/framer-motion/static-1.82",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3540",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.15",
  "testing-library": "/testing-library/static-1.162",
  "ts-schema": "/ts-schema/static-1.4350",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "react-utils": "/react-utils/static-2.5611",
  "StyleGuideUI": "/StyleGuideUI/static-3.511",
  "jasmine": "/jasmine/static-4.4702",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.468",
  "chirp-fetch": "/chirp-fetch/static-1.2293",
  "HubStyle": "/HubStyle/static-2.12191",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5138",
  "cssUtils": "/cssUtils/static-1.1013",
  "hs-story-utils": "/hs-story-utils/static-1.9816",
  "icons": "/icons/static-2.698",
  "react-create-root-preference": "/react-create-root-preference/static-1.87",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-virtualized": "/react-virtualized/static-2.110",
  "ui-images": "/ui-images/static-2.1268",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4891",
  "floating-ui": "/floating-ui/static-1.66",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2587",
  "react-aria": "/react-aria/static-1.75",
  "tanstack-table": "/tanstack-table/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.2878",
  "ui-fonts": "/ui-fonts/static-1.1146",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1647",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3354",
  "foundations-theming-base": "/foundations-theming-base/static-1.3856",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.350",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.177",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.895",
  "hubspotter-http": "/hubspotter-http/static-1.4916",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.591",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.552",
  "quartz-auth": "/quartz-auth/static-1.1236",
  "quartz-head": "/quartz-head/static-1.1226",
  "quartz-i18n": "/quartz-i18n/static-1.1236",
  "quartz-test": "/quartz-test/static-1.1236",
  "quartz-tracking": "/quartz-tracking/static-1.940",
  "trellis-components": "/trellis-components/static-1.2897",
  "usage-tracker-container": "/usage-tracker-container/static-1.7693",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.81",
  "sassPrefix": "/sassPrefix/static-1.281",
  "stylex-utils": "/stylex-utils/static-1.156",
  "trellis-theming": "/trellis-theming/static-1.1369",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.94",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10756",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5389",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
